// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ewqF","placeholdersHeader":"styles_placeholdersHeader__1Hk8N","editorStyle":"styles_editorStyle__W7k--","placeholdersBox":"styles_placeholdersBox__2Nz7Q"};